export enum IdentificationType
{
    PASSPORT = 1, 
    IDENTIFICATIONCARD = 2
}